// extracted by mini-css-extract-plugin
export var activityContainer = "_lf-0";
export var typingIndicatorContainer = "_lf-1";
export var typingIndicatorDot = "_lf-2";
export var wave = "_lf-3";